var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "c-table",
    {
      ref: "table",
      attrs: {
        title: "위험형태별 원인 목록",
        columns: _vm.grid.columns,
        gridHeight: _vm.grid.height,
        data: _vm.grid.data,
        filtering: false,
        columnSetting: false,
        editable: _vm.editable,
      },
    },
    [
      _c(
        "template",
        { slot: "table-button" },
        [
          _c(
            "q-btn-group",
            { attrs: { outline: "" } },
            [
              _vm.editable && _vm.visible
                ? _c("c-btn", {
                    attrs: { label: "추가", icon: "add" },
                    on: { btnClicked: _vm.add },
                  })
                : _vm._e(),
              _vm.editable && _vm.visible
                ? _c("c-btn", {
                    attrs: { label: "저장", icon: "save" },
                    on: { btnClicked: _vm.save },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }